export interface AccessClaims {
  isSecurityAdministrator?: boolean;
  hasFullApplicationAccess?: boolean;
  permissions?: Record<string, string[]>;
}

export function hasPermission(
  claims: AccessClaims | undefined,
  namespace: string,
  permission: string,
): boolean {
  const groups = claims?.permissions;
  if (!groups || typeof groups !== 'object' || Array.isArray(groups))
    return false;
  const values = groups[namespace];
  return (
    Array.isArray(values) &&
    values.every((value) => typeof value === 'string') &&
    values.includes(permission)
  );
}

export function hasApplicationPermission(
  claims: AccessClaims | undefined,
  namespace: string,
  permission: string,
): boolean {
  return (
    claims?.hasFullApplicationAccess === true ||
    hasPermission(claims, namespace, permission)
  );
}
